import React from 'react';
import PropTypes from 'prop-types';
import {
  ButtonPrimary,
} from '@americanexpress/dls-react';
import {
  RawIntlProvider, FormattedMessage, createIntlCache, createIntl, useIntl,
} from 'react-intl';
import SideBar from '../../Common/SideBar';
import bybCopy from '../../../../locale/de-DE/bybCopy.json';
import { useProductContext } from '../../Product';

const cache = createIntlCache();

const bybIntl = createIntl({
  locale: 'es-MX',
  messages: bybCopy,
}, cache);

const ProductBYB = ({ next }) => {
  document.body.style.backgroundColor = '';
  const {
    product: { productShortName },
  } = useProductContext();
  const {
    messages: {
      links: {
        BYBPageList3Link,
      },
    },
  } = useIntl();

  return (
    <div className="container">
      <div className="row margin-4-t">
        <div className="col-lg-9 col-xl-7">
          <form onSubmit={() => next()}>
            <RawIntlProvider value={bybIntl}>
              <div className="col-md-11 pad-4-r">
                <h2 className="heading-5">
                  <FormattedMessage id="BYBPage.title" />
                </h2>
                <h3 className="heading-4 pad-1-tb">
                  <FormattedMessage id="BYBPage.header" />
                </h3>
                <p className="margin-1-b"><FormattedMessage id="BYBPage.subHeading" /></p>
                <ul>
                  <li className="font-weight-bold"><FormattedMessage id={`BYBPage.list1.${productShortName}`} /></li>
                  <li><FormattedMessage id="BYBPage.list2" /></li>
                  <li className="font-weight-bold">
                    <span className="pad-1-b pad-1-t">
                      <FormattedMessage id="BYBPage.list3.subText1" />
                    </span>
                    <a href={BYBPageList3Link} target="_blank" className="text-underline" aria-label="papericonlink" rel="noopener noreferrer">
                      <FormattedMessage id="BYBPage.list3.link" />
                    </a>
                    <span>
                      <FormattedMessage id="BYBPage.list3.subText2" />
                    </span>
                  </li>
                  <li><FormattedMessage id="BYBPage.list4" /></li>
                  <li><FormattedMessage id="BYBPage.list5" /></li>
                  <li><FormattedMessage id="BYBPage.list6" /></li>
                </ul>
              </div>
              <div className="flex flex-justify-center">
                <div className="margin-4-tb">
                  <ButtonPrimary
                    type="submit"
                    className="margin-center display-block"
                    style={{ minWidth: '15.625rem' }}
                    reactlytics={{ element: 'Continue', detail: 'Application' }}
                  >
                    <FormattedMessage id="BYBPage.continue" default="BYBPage.continue" />
                  </ButtonPrimary>
                </div>
              </div>
            </RawIntlProvider>
          </form>
        </div>
        <div className="col-lg-3 col-xl-3 col-xl-offset-1">
          <SideBar />
        </div>
      </div>
    </div>
  );
};

ProductBYB.propTypes = {
  next: PropTypes.func.isRequired,
};

export default ProductBYB;
